import { createContext, useContext } from 'react';

import type { PendingOrdersContextValue } from 'pages/pending_orders';

export const PendingOrdersContext = createContext({} as PendingOrdersContextValue);
PendingOrdersContext.displayName = 'PendingOrdersContext';

export const usePendingOrders = () => useContext(PendingOrdersContext);
